import React from "react";
import { Card, CardBody, Container, Row, Col } from "reactstrap";
import { ChartLine, User } from "lucide-react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Reusable component for each report card
const ReportItem = ({ to, icon: Icon, iconClass, title }) => (
  <Col xs="6" sm="6" md="6" lg="6" className="d-flex">
    <Link
      to={to}
      style={{ textDecoration: "none", color: "inherit", width: "100%" }}
    >
      <Card
        className="h-100 text-center shadow-sm hover-shadow mb-3 w-100"
        style={{ cursor: "pointer" }}
      >
        <CardBody>
          <Icon size={40} className={`${iconClass} mb-3`} />
          <h5>{title}</h5>
        </CardBody>
      </Card>
    </Link>
  </Col>
);

const ReportCard = () => {
  const breadcrumbItems = [
    { title: "Home", link: "/" },
    { title: "Reports", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Report" breadcrumbItems={breadcrumbItems} />
          <Row className="row-cols-2 g-3 d-flex align-items-stretch">
            <ReportItem
              to="/attendance-report"
              icon={ChartLine}
              iconClass="text-primary"
              title="Attendance Report"
            />
            <ReportItem
              to="/student-report"
              icon={User}
              iconClass="text-success"
              title="Student Report"
            />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ReportCard;
